
import React, { createContext, useState, useEffect } from 'react';
import { LocalStorageService } from './services'
import socketio from "socket.io-client";


const defaultState = {
    setShowError: () => { }
};

//Socket Context 
export const socket = socketio.connect(process.env.REACT_APP_ETICKET_API_SOCKET);
export const SocketContext = React.createContext();

export const Context = createContext(defaultState);

export const ContextProvider = (props) => {
    const [showSignatureCanvas, setShowSignatureCanvas] = useState(false)
    const [showPdf, setShowPdf] = useState(false)
    const [pdf, setPdf] = useState(null)
    const [pdfSucess, setPdfSucess] = useState(null)
    const [canvasData, setCanvasData] = useState({})
    const [clientLogo, setclientLogo] = useState()

    const [navActions, setNavActions] = useState({ notifications: false, settings: false, profile: false })
    const [allowedActions, setAllowedActions] = useState({ read: true }) // per module

    let localStorageService = new LocalStorageService()

    useEffect(() => {
        if (props.logo) {
            setclientLogo(props.logo)
            localStorageService.setLocalStorageItem('clientLogo', props.logo)
        } else {
            let logo = localStorageService.getLocalStorageItem('clientLogo')
            if (logo) {
                setclientLogo(logo)
            } else setclientLogo('')
        }
    }, [props.logo])

    useEffect(() => {
        const user = localStorageService.getLocalStorageItem('user')
        const userRoles = user.userMetaData.userRoles
        const isAdmin = userRoles.find(userRole => userRole.role.key === process.env.REACT_APP_ROLE_GENERAL_ADMIN)
        setNavActions({ notifications: true, settings: !!isAdmin, profile: true })
    }, [props.drawerItems])

    const params = {
        pdfSucess, setPdfSucess,
        visibleDialogTimerSignOff: props.visibleDialogTimerSignOff,
        setShowError: props.setShowError,
        showSignatureCanvas,
        setShowSignatureCanvas,
        canvasData,
        setCanvasData,
        showPdf,
        setShowPdf,
        pdf,
        setPdf,
        clientLogo,
        setclientLogo,
        allowedActions,
        setAllowedActions,
        navActions,
        setNavActions
    }
    return (
        <Context.Provider value={params} >
            {props.children(params)}
        </Context.Provider>
    )
};